import React, { useState, useEffect } from "react"
import InternalNavItem from "./InternalNavItem"

import { InternalNavContainer, Nav, TitleWrapper, PrimaryList } from "./style"

const InternalNav = ({ page, ancestors, currentPageLink }) => {
  let sectionPages = ancestors
    ? ancestors[ancestors.length - 1].childPages.nodes
    : []
  const initialNavIndex = getInitialOpenNav(sectionPages, currentPageLink)

  const [itemClicked, setItemClicked] = useState(initialNavIndex)

  return (
    <InternalNavContainer>
      <TitleWrapper>
        <h3>In this section</h3>
      </TitleWrapper>
      <Nav>
        <PrimaryList>
          {sectionPages.map((item, index) => {
            return (
              <InternalNavItem
                key={index}
                label={item.title}
                link={item.link}
                nestedItems={item.childPages}
                id={index}
                itemClicked={itemClicked}
                setItemClicked={setItemClicked}
              />
            )
          })}
        </PrimaryList>
      </Nav>
    </InternalNavContainer>
  )
}

export default InternalNav

const getInitialOpenNav = (sectionPages, currentPageLink) => {
  let initialNavIndex = 0

  sectionPages.forEach((page, index) => {
    if (page.link === currentPageLink) {
      initialNavIndex = index
    }

    if (page.childPages && page.childPages.nodes.length > 0) {
      page.childPages.nodes.forEach(page => {
        if (page.link === currentPageLink) {
          initialNavIndex = index
        } else if (page.childPages && page.childPages.nodes.length > 0) {
          page.childPages.nodes.forEach(page => {
            if (page.link === currentPageLink) {
              initialNavIndex = index
            }
          })
        }
      })
    }
  })

  return initialNavIndex
}
